// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content_A_V7B {
  display : -webkit-box;
  display : -ms-flexbox;
  display : flex;
  -webkit-box-pack : start;
      -ms-flex-pack : start;
          justify-content : flex-start;
  -webkit-box-align : center;
      -ms-flex-align : center;
          align-items : center;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
      -ms-flex-direction: row;
          flex-direction: row;
  -ms-flex-wrap: nowrap;
      flex-wrap: nowrap;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/ui-elements/lib/esm/Breadcrumbs.css"],"names":[],"mappings":"AAAA;EACE,qBAAc;EAAd,qBAAc;EAAd,cAAc;EACd,wBAA4B;MAA5B,qBAA4B;UAA5B,4BAA4B;EAC5B,0BAAoB;MAApB,uBAAoB;UAApB,oBAAoB;EACpB,8BAAmB;EAAnB,6BAAmB;MAAnB,uBAAmB;UAAnB,mBAAmB;EACnB,qBAAiB;MAAjB,iBAAiB;AACnB","sourcesContent":[".content {\n  display : flex;\n  justify-content : flex-start;\n  align-items : center;\n  flex-direction: row;\n  flex-wrap: nowrap;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `content_A_V7B`
};
export default ___CSS_LOADER_EXPORT___;
